
import React, { useState,useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CloudProLFConfig from "./CloudProLFConfig";
import CloudProSVConfig from "./CloudProSVConfig";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Axios from "axios";
import { panelFromProjectDocument } from "./workflowPanelData";
const CloudProConfigurationPage = () => {


  const navigate = useNavigate();
  const location = useLocation();
const incomingLF = location.state?.lfName;
const incomingSV = location.state?.svName;
const incomingMode = location.state?.activeMode;
 const [activeMode, setActiveMode] = useState(
  incomingMode || "LF"
);

const [selectedLF, setSelectedLF] = useState(
  incomingLF || null
);

const [selectedSV, setSelectedSV] = useState(
  incomingSV || null
);
  const [lfOptions, setLfOptions] = useState(["L1", "L2", "L3"]);
useEffect(() => {
  if (incomingLF) {
    setSelectedLF(incomingLF.replace("LF", "L"));
  }
}, [incomingLF]);
 useEffect(() => {
  if (incomingSV) {
    setSelectedSV(incomingSV);
  }
 }, [incomingSV]);
  const SV_OPTIONS = ["SV1", "SV2", "SV3"];
  const [data, setData] = useState([]);


  const { mdId, rowIndex, colIndex } = useParams();
  const [panelReady, setPanelReady] = useState(false);
  const [panelLoadError, setPanelLoadError] = useState("");
  const [panelVersionKey, setPanelVersionKey] = useState(0);
  const [refreshSeq, setRefreshSeq] = useState(0);
  useEffect(() => {
    const onRefresh = () => setRefreshSeq(n => n + 1);
    window.addEventListener("project-refreshed", onRefresh);
    return () => window.removeEventListener("project-refreshed", onRefresh);
  }, []);
  const handleModeChange = (mode) => {
    setActiveMode(mode);
  };
  const handleAddSVOption = () => {
    const next = svOptions.length + 1;
    setSvOptions((prev) => [...prev, `SV${next}`]);
  };

  const [svOptions, setSvOptions] = useState(["SV1", "SV2"]);
  const OUTPUT_ZONES = ["Zone 1", "Zone 2", "Zone 3", "Zone 4"];
  const [selectedCell, setSelectedCell] = useState({ rowIndex: null, colIndex: null });
  const [lfList, setLfList] = useState([]);
 
  const [svList, setSvList] = useState([]);
 
  const DEVICE_OPTIONS = ["Detector 1", "Detector 2", "MCP 1", "Flow Switch"];
  const ZONE_OPTIONS = ["Zone 1", "Zone 2", "Zone 3", "Zone 4"];
  const [selectedDevice, setSelectedDevice] = useState("");
  const [selectedZone, setSelectedZone] = useState("");

  const handleAddLFOption = () => {
    const nextNumber = lfOptions.length + 1;
    const newLF = `L${nextNumber}`;
    setLfOptions((prev) => [...prev, newLF]);
  };
  const updateLF = (id, field, value) => {
    setLfList((prev) =>
      prev.map((lf) => (lf.id === id ? { ...lf, [field]: value } : lf))
    );
  };
  const updateSV = (id, field, value) => {
    setSvList((prev) =>
      prev.map((sv) => (sv.id === id ? { ...sv, [field]: value } : sv))
    );
  };
  const selectedProject = JSON.parse(sessionStorage.getItem("selectedProject"));
  const projectId = selectedProject?.project_id;
  useEffect(() => {
    if (!projectId) return;
    let current = true;
    setPanelReady(false);
    setPanelLoadError("");
    const load = async () => {
      const { data: listing } = await Axios.post("/get_customer_project", { mdId, projectId,
        siId: localStorage.getItem("siId") || "" });
      const entries = (listing?.projectVariants || []).filter(p => p.panelContent_id);
      const panelNumber = Number(sessionStorage.getItem("causeEffectPanelNumber"));
      const id = (entries.find(p => Number(p.vtnetPanelAddress) === panelNumber) || entries[0])?.panelContent_id;
      if (!id) throw new Error("Select a panel to view its configuration.");
      const { data } = await Axios.post("/get_customer_panel", { mdId, projectId,
        siId: localStorage.getItem("siId") || "", panelContentId: id });
      if (!data?.success || !data.panel) throw new Error(data?.msg || "Panel not found");
      if (!current) return;
      const fresh = JSON.parse(sessionStorage.getItem("selectedProject") || "null");
      if (!fresh || fresh.project_id !== projectId) return;
      const fullPanel = panelFromProjectDocument(data.panel, {
        panelNumber: Number(data.panel.generalparameters?.vtnetPanelAddress),
      });
      sessionStorage.setItem("selectedProject", JSON.stringify({ ...fresh, panel: fullPanel }));
      sessionStorage.setItem("panelContentId", id);
      console.log("Configuration panel (complete project data):", fullPanel);
      setSelectedLF(null);
      setSelectedSV(null);
      setPanelVersionKey(n => n + 1);
      setPanelReady(true);
    };
    load().catch(error => {
      if (current) { setPanelLoadError(error.message); setPanelReady(true); }
    });
    return () => { current = false; };
  }, [projectId, mdId, refreshSeq]);
  if (!selectedProject) {
    return (
      <div style={{ padding: "20px", color: "red", textAlign: "center" }}>
        Please select a project first
      </div>
    );
  }

  const panelVersion=sessionStorage.getItem("panelVersion1");
  const hasSavedSV = selectedProject?.panel?.VT5000_CONFIG?.Dependency?.some(
    dependency => Number(dependency?.dependencyType) === 3
  );
  const isSVEnabled = panelVersion?.toLowerCase().includes("f9") || hasSavedSV;
  return (
    <>

      <div className="project-container">
        <div className="glass-card">
          <Card sx={{ minWidth: 275 }}>
            <CardContent></CardContent>
            <div >
              <div style={{ width: "90%", maxWidth: "600px", padding: "8px", }}>


                <div style={{ display: "flex", gap: "10px", marginBottom: "5px" }}>
                  <button
                    onClick={() => handleModeChange("LF")}
                    style={{
                      flex: 1,
                      padding: "8px",
                      background: activeMode === "LF" ? "#007bff" : "#eee",
                      color: activeMode === "LF" ? "#fff" : "#000",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    LOGIC FUNCTION
                  </button>
                  <button
                    onClick={() => handleModeChange("SV")}
                      disabled={!isSVEnabled}
                    style={{
                        flex: 1,
                        padding: "8px",
                        background: activeMode === "SV" ? "#28a745" : "#eee",
                        color: activeMode === "SV" ? "#fff" : "#000",
                        border: "none",
                        borderRadius: "5px",
                        cursor: isSVEnabled ? "pointer" : "not-allowed",
                        opacity: isSVEnabled ? 1 : 0.5,
                      }}>
                    SMART VERIFY
                  </button>
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(80px, 1fr))",
                    gap: "10px",
                    marginBottom: "15px",
                  }}
                >
                  {panelLoadError && <div role="alert">{panelLoadError}</div>}
                  {!panelReady && <div>Loading panel configuration...</div>}
                  {panelReady && !panelLoadError && activeMode === "LF" && (
                    <CloudProLFConfig
                      key={`lf-${panelVersionKey}`}
                      lfOptions={lfOptions}
                      selectedLF={selectedLF}
                      setSelectedLF={setSelectedLF}
                      handleAddLF={handleAddLFOption}
                      handleAddLFOption={handleAddLFOption}
                      lfList={lfList}
                      setLfList={setLfList}
                      selectedCell={selectedCell}
                      activeMode={activeMode}

                      updateLF={updateLF}

                      DEVICE_OPTIONS={DEVICE_OPTIONS}
                      ZONE_OPTIONS={ZONE_OPTIONS}
                      selectedDevice={selectedDevice}
                      setSelectedDevice={setSelectedDevice}
                      selectedZone={selectedZone}
                      setSelectedZone={setSelectedZone}
                      OUTPUT_ZONES={OUTPUT_ZONES}
                      setActiveMode={setActiveMode} />)}
                  {panelReady && !panelLoadError && activeMode === "SV" && (
                    <CloudProSVConfig key={`sv-${panelVersionKey}`} selectedSV={selectedSV}
                      svOptions={svOptions} activeMode={activeMode} handleAddSVOption={handleAddSVOption} selectedCell={selectedCell} svList={svList} setSvList={setSvList} updateSV={updateSV}
                     
                      setActiveMode={setActiveMode}
                    />
                  )}
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};

export default CloudProConfigurationPage;
